export default {
    filters: {
        title: 'Filters',
        removeFilter: 'Remove Filter',
        filterIntensity: 'Filter intensity',
        duotone: {
            title: 'Duotone',
            desert: 'Desert',
            peach: 'Peach',
            clash: 'Clash',
            plum: 'Plum',
            breezy: 'Breezy',
            deepBlue: 'Deep Blue',
            frog: 'Frog',
            sunset: 'Sunset',
        },
        blackAndWhite: {
            title: 'B & W',
            ad: '1920 A.D.',
            greyed: 'Greyed',
            dusty: 'Dusty',
            litho: 'Litho',
            sepia: 'Sepia',
            weathered: 'Weathered',
            hardStuff: 'Hard Stuff',
        },
        vintage: {
            title: 'Vintage',
            polaroid: 'Polaroid',
            sunny: 'Sunny 70s',
            oldTimer: 'Oldtimer',
            inferno: 'Inferno',
            snappy: 'Snappy',
        },
        smooth: {
            title: 'Smooth',
            chestnut: 'Chestnut',
            softy: 'Softy',
            pebble: 'Pebble',
            moss: 'Moss',
            lemon: 'Lemon',
            greenGap: 'Green Gap',
        },
        cold: {
            title: 'Cold',
            colla: 'Colla',
            solanus: 'Solanus',
            kalmen: 'Kalmen',
            jorah: 'Joran',
            levante: 'Levante',
            zephyr: 'Zephyr',
        },
        warm: {
            title: 'Warm',
            golden: 'Golden',
            lowFire: 'Low Fire',
            sunrise: 'Sunrise',
            flatBack: 'Flat Back',
            pumpkin: 'Pumpkin',
        }
    },
};
